'use client';

import { FC, useEffect, useRef } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useDispatch } from 'react-redux';
import { useTranslations } from 'next-intl';
import { toast } from '@/hotdesk-ui/components/toast-v4';
import { handleMagicLink, MAGIC_LINK_TYPE, stripMagicLinkParams } from '@/hotdesk-ui/services/magic-link.service';
import { openAuthModalAt } from '@/hotdesk-ui/store/slices/auth.slice';
interface MagicLinkBootstrapProps {
  language: string;
}
const MagicLinkBootstrap: FC<MagicLinkBootstrapProps> = ({
  language
}) => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  const dispatch = useDispatch();
  const t = useTranslations();
  const handledRef = useRef(false);
  useEffect(() => {
    if (handledRef.current) return;
    if (!searchParams) return;
    if (searchParams.get('type') !== MAGIC_LINK_TYPE) return;
    handledRef.current = true;
    (async () => {
      const params = new URLSearchParams(searchParams.toString());
      const outcome = await handleMagicLink(params, language);
      const cleanQuery = stripMagicLinkParams(searchParams.toString());
      const cleanUrl = `${pathname}${cleanQuery}`;
      if (outcome.kind === 'success') {
        if (outcome.redirectTo) {
          window.location.href = outcome.redirectTo;
          return;
        }
        router.replace(cleanUrl);
        return;
      }
      if (outcome.kind === 'reset-password') {
        router.replace(cleanUrl);
        dispatch(openAuthModalAt({
          step: 'reset',
          email: outcome.email
        }));
        return;
      }
      if (outcome.kind === 'failure') {
        router.replace(cleanUrl);
        toast.error(t('auth.magicLink.error'), {
          position: 'bottom-center'
        });
      }
    })();
  }, [searchParams, pathname, language, router, dispatch, t]);
  return null;
};
export default MagicLinkBootstrap;